import {Dispatchable} from "../../../../stem-core/src/base/Dispatcher";


export class Condition extends Dispatchable {
    /** @type {Condition[]} */
    ops = [];

    // requestReEval asks a reeval for the whole condition tree. Assume to be throttled already.
    constructor(journey, options, requestReEval) {
        super();
        this.journey = journey;
        this.options = options;
        // Wrap in a lambda for each instance of Condition to avoid Stem Dispatcher's error about
        // "Can't re-register for the same callback: ...".
        this.requestReEval = () => requestReEval();
    }

    // Returns true or false if can be evaluated, null if evaluation can't be made so far.
    evaluate() {
        return null;
    }

    cleanup() {
        super.cleanup();
        this.ops.forEach(subCondition => subCondition.cleanup());
    }
}
